/**
 * Map opaque browser/network failures (e.g. Safari "Load failed") to actionable copy.
 */
export function friendlyNetworkError(err, fallback = "Request failed.") {
  const msg = String(err?.message || err || "").trim();
  if (!msg) return fallback;

  if (
    /load failed|failed to fetch|networkerror|network request failed|fetch failed|err_name_not_resolved|err_connection|could not resolve/i.test(
      msg
    )
  ) {
    return (
      "Cannot reach the VedaPath API (network error). " +
      "Check that the Worker is deployed and REACT_APP_BACKEND_URL / proxy points at it."
    );
  }

  return msg;
}
